import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { ActivityIndicator, View, StyleSheet, Text } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';

import Colors from '../constants/Colors';
import Languages from '../constants/Languages';
import * as Actions from '../store/Actions';
import NoVisitsPage from '../components/visit/NoVisitsPage';
import VisitList from '../components/visit/VisitList';
import TopMenu from '../navigation/TopMenu';
import { getToken } from '../utils/token';

class VisitScreen extends Component {
  static propTypes = {
    actions: PropTypes.objectOf(PropTypes.any).isRequired,
    registration: PropTypes.objectOf(PropTypes.any).isRequired,
    pantry: PropTypes.objectOf(PropTypes.any).isRequired,
    navigation: PropTypes.objectOf(PropTypes.any),
  };

  constructor(props) {
    super();
    this.state = {
      visits: [],
      lastApiCall: 0,
      isLoading: true,
      isLoggedIn: false,
    };
  }

  spinnerTimer = null;

  componentDidMount = async () => {
    const { actions, navigation } = this.props;
    const token = await getToken();
    const isLoggedIn = Boolean(token);

    const now = new Date().getTime();
    this.setState({ lastApiCall: now });
    if (isLoggedIn) {
      this.spinnerTimer = setTimeout(() => {
        this.setState({ isLoading: false });
      }, 2000);
      actions.getVisits();
    } else {
      this.setState({ isLoading: false });
    }
  };

  componentDidUpdate = async () => {
    const { pantry } = this.props;
    const { visits, lastApiCall } = pantry;
    if (visits && visits.length && lastApiCall > this.state.lastApiCall) {
      this.setState({ visits, lastApiCall });
    }
  };

  componentWillUnmount() {
    if (this.spinnerTimer) clearTimeout(this.spinnerTimer);
  }

  capitalize = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  render() {
    const { actions, registration, pantry, navigation } = this.props;
    const { isLoading } = this.state;
    const { language } = registration;
    const locale = language?.name || 'en';
    const translation = Languages.translations[locale];
    const { visits } = this.state;
    let content = null;
    if (isLoading) {
      content = (
        <View style={styles.container}>
          <View style={styles.header}>
            <Text style={styles.headerText}>
              {this.capitalize(translation.fragment_main_bottombar_visits)}
            </Text>
          </View>
          <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
            <ActivityIndicator size="large" color={Colors.mediumBlue} />
          </View>
        </View>
      );
    } else if (visits && visits.length) {
      content = (
        <VisitList
          translation={translation}
          locale={locale}
          visits={pantry.visits}
          actions={actions}
          navigation={navigation}
          registration={registration}
        />
      );
    } else {
      content = <NoVisitsPage translation={translation} registration={registration} />;
    }

    const props = Object.assign({}, this.props, { page: 'visits' }, { translation });

    return (
      <SafeAreaView style={styles.container}>
        <View style={styles.view}>
          <TopMenu {...props} />
          {content}
        </View>
      </SafeAreaView>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Colors.white,
  },
  view: {
    color: Colors.primaryColor,
    backgroundColor: Colors.white,
    flex: 1,
  },
  header: {
    backgroundColor: Colors.white,
    borderBottomColor: Colors.grayBorder,
    borderBottomWidth: 1,
    height: 56,
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
  },
  headerText: {
    color: Colors.mediumBlue,
    fontSize: 20,
    fontWeight: '500',
  },
});

function mapStateToProps(state) {
  return {
    registration: state.registration,
    pantry: state.pantry,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Actions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(VisitScreen);
